var _effectorFileName = "/builds/gmini/front-ui-kit/src/Paper/Paper.styled.ts";
import styled, { css } from 'styled-components';
const PaperRoot = css`
  color: rgba(0, 0, 0, 0.87);
  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  background-color: #fff;
  border-radius: 4px;
`;
const PaperElevation1 = css`
  box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%),
    0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);
`;
const PaperElevation2 = css`
  box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
    0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
`;
const PaperElevation3 = css`
  box-shadow: 0px 3px 3px -2px rgb(0 0 0 / 20%),
    0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%);
`;
const PaperElevation4 = css`
  box-shadow: 0px 2px 4px -1px rgb(0 0 0 / 20%),
    0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%);
`;
const PaperElevation5 = css`
  box-shadow: 0px 3px 5px -1px rgb(0 0 0 / 20%),
    0px 5px 8px 0px rgb(0 0 0 / 14%), 0px 1px 14px 0px rgb(0 0 0 / 12%);
`;
const PaperElevation6 = css`
  box-shadow: 0px 3px 5px -1px rgb(0 0 0 / 20%),
    0px 6px 10px 0px rgb(0 0 0 / 14%), 0px 1px 18px 0px rgb(0 0 0 / 12%);
`;
const PaperElevation7 = css`
  box-shadow: 0px 4px 5px -2px rgb(0 0 0 / 20%),
    0px 7px 10px 1px rgb(0 0 0 / 14%), 0px 2px 16px 1px rgb(0 0 0 / 12%);
`;
const PaperElevation8 = css`
  box-shadow: 0px 5px 5px -3px rgb(0 0 0 / 20%),
    0px 8px 10px 1px rgb(0 0 0 / 14%), 0px 3px 14px 2px rgb(0 0 0 / 12%);
`;
const PaperElevation9 = css`
  box-shadow: 0px 5px 6px -3px rgb(0 0 0 / 20%),
    0px 9px 12px 1px rgb(0 0 0 / 14%), 0px 3px 16px 2px rgb(0 0 0 / 12%);
`;
const PaperElevation10 = css`
  box-shadow: 0px 6px 6px -3px rgb(0 0 0 / 20%),
    0px 10px 14px 1px rgb(0 0 0 / 14%), 0px 4px 18px 3px rgb(0 0 0 / 12%);
`;
const PaperElevation24 = css`
  box-shadow: 0px 11px 15px -7px rgb(0 0 0 / 20%),
    0px 24px 38px 3px rgb(0 0 0 / 14%), 0px 9px 46px 8px rgb(0 0 0 / 12%);
`;
export const PaperWrapper = styled.div`
  ${props => props.className.includes('Paper-root') ? PaperRoot : ''};
  ${props => {
  switch (props.elevation) {
    case 1:
      return PaperElevation1;

    case 2:
      return PaperElevation2;

    case 3:
      return PaperElevation3;

    case 4:
      return PaperElevation4;

    case 5:
      return PaperElevation5;

    case 6:
      return PaperElevation6;

    case 7:
      return PaperElevation7;

    case 8:
      return PaperElevation8;

    case 9:
      return PaperElevation9;

    case 10:
      return PaperElevation10;

    case 24:
      return PaperElevation24;
  }
}}
`;